<div class="container">
  <div class="row no-gutters">
    <div class="col-12">
      <div class="d-flex popup-head align-items-center">
        <div class="popup-title mr-auto" translate>
          lblAddNewVehicle
        </div>
        <div class="float-right">
          <a class="close mr-2" (click)="OnClose()" translate>
            <span class="" aria-hidden="true">&times;</span>
            </a>
        </div>
      </div>
      <div>
        <app-vehicle-list [IsAddNewVehicle]="true" [isAddFromAppointment]="isAddFromAppointment" [vehicleDetails]="vehicleDetail"></app-vehicle-list>
      </div>
    </div>
  </div>
</div>
